module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [((_vm.IsLive || _vm.isIB) && _vm.IsVerified) ? [(_vm.User.info) ? _c('new-terms-modal', {
    attrs: {
      "user-id": _vm.User.info.ID
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    class: {
      'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "selectPlatformText"
    }
  }, [_vm._v(_vm._s(_vm.$t("choose_your_desired_trading_platform_and_settings").tTitle()))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "accountPlatformContainer",
    class: {
      'selected': _vm.platform == 'mt4', 'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    on: {
      "click": function($event) {
        _vm.platform = 'mt4'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mt4Logo"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mt4Inputs"
    }
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.currency),
      expression: "mt4.currency"
    }],
    attrs: {
      "id": "mt4Currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_currency").tTitle()))]), _vm._v(" "), _vm._l((_vm.$getCurrencies()), function(c, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i) + " (" + _vm._s(c.symbol) + ")")])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.group),
      expression: "mt4.group"
    }],
    attrs: {
      "id": "mt4AccountType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_account_type").tTitle()))]), _vm._v(" "), _vm._l((_vm.mt4.groupOptions), function(g, i) {
    return _c('option', {
      key: i,
      attrs: {
        "data-currency": g.currency
      },
      domProps: {
        "value": g.name
      }
    }, [_vm._v(_vm._s(g.display_name) + _vm._s((_vm.mt4.currency == '' ? " (" + g.currency + ")" : "")))])
  })], 2)]), _vm._v(" "), (_vm.mt4.group === 'pamm-investor') ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "text-align": "left",
      "margin": "5px 0 10px",
      "color": "black"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pamm_investor_selection_note")) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.leverage),
      expression: "mt4.leverage"
    }],
    attrs: {
      "id": "mt4Leverage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt4, "leverage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_leverage").tTitle()))]), _vm._v(" "), _vm._l((_vm.leverages), function(l, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": l.leverage
      }
    }, [_vm._v("1:" + _vm._s(l.leverage))])
  })], 2)]), _vm._v(" "), (_vm.BonusConfig.depositBonus.enabled && _vm.mt4.group !== 'pamm-investor' && _vm.mt4.group !== 'vip') ? _c('label', {
    staticClass: "label",
    class: {
      'custom-disabled': _vm.mt4.group === 'pamm-investor'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt4.acceptBonus),
      expression: "mt4.acceptBonus"
    }],
    attrs: {
      "id": "acceptBonus",
      "type": "checkbox",
      "disabled": _vm.mt4.group === 'pamm-investor'
    },
    domProps: {
      "checked": Array.isArray(_vm.mt4.acceptBonus) ? _vm._i(_vm.mt4.acceptBonus, null) > -1 : (_vm.mt4.acceptBonus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.mt4.acceptBonus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.mt4, "acceptBonus", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.mt4, "acceptBonus", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.mt4, "acceptBonus", $$c)
        }
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t("include_account_in_bonus_program").tTitle()) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.createTradingAccount('mt4')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("create").tUpper()))])]), _vm._v(" "), _c('div', {
    staticClass: "accountPlatformContainer",
    class: {
      'selected': _vm.platform == 'mt5', 'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    on: {
      "click": function($event) {
        _vm.platform = 'mt5'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mt5Logo"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mt5Inputs"
    }
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.currency),
      expression: "mt5.currency"
    }],
    attrs: {
      "id": "mt5Currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_currency").tTitle()))]), _vm._v(" "), _vm._l((_vm.$getCurrencies()), function(c, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i) + " (" + _vm._s(c.symbol) + ")")])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.group),
      expression: "mt5.group"
    }],
    attrs: {
      "id": "mt5AccountType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_account_type").tTitle()))]), _vm._v(" "), _vm._l((_vm.mt5.groupOptions), function(g, i) {
    return _c('option', {
      key: i,
      attrs: {
        "data-currency": g.currency
      },
      domProps: {
        "value": g.name
      }
    }, [_vm._v(_vm._s(g.display_name) + _vm._s((_vm.mt5.currency == '' ? " (" + g.currency + ")" : "")))])
  })], 2)]), _vm._v(" "), (_vm.mt5.group === 'pamm-investor') ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "text-align": "left",
      "margin": "5px 0 10px",
      "color": "black"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pamm_investor_selection_note")) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.leverage),
      expression: "mt5.leverage"
    }],
    attrs: {
      "id": "mt5Leverage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mt5, "leverage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_leverage").tTitle()))]), _vm._v(" "), _vm._l((_vm.leverages), function(l, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": l.leverage
      }
    }, [_vm._v("1:" + _vm._s(l.leverage))])
  })], 2)]), _vm._v(" "), (_vm.BonusConfig.depositBonus.enabled && _vm.mt5.group !== 'pamm-investor' && _vm.mt5.group !== 'vip') ? _c('label', {
    staticClass: "label",
    class: {
      'custom-disabled': _vm.mt5.group === 'pamm-investor'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mt5.acceptBonus),
      expression: "mt5.acceptBonus"
    }],
    attrs: {
      "id": "acceptBonus",
      "type": "checkbox",
      "disabled": _vm.mt5.group === 'pamm-investor'
    },
    domProps: {
      "checked": Array.isArray(_vm.mt5.acceptBonus) ? _vm._i(_vm.mt5.acceptBonus, null) > -1 : (_vm.mt5.acceptBonus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.mt5.acceptBonus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.mt5, "acceptBonus", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.mt5, "acceptBonus", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.mt5, "acceptBonus", $$c)
        }
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t("include_account_in_bonus_program").tTitle()) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.createTradingAccount('mt5')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("create").tUpper()))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "accountPlatformContainer",
    class: {
      'selected': _vm.platform == 'pamm'
    },
    on: {
      "click": function($event) {
        _vm.platform = 'pamm'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "pammLogo"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pammInputs"
    }
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pamm.accountGroup),
      expression: "pamm.accountGroup"
    }],
    attrs: {
      "id": "pammAccountType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pamm, "accountGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_account_type").tTitle()))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "detached"
    }
  }, [_vm._v("Investor")])])]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pamm.leverage),
      expression: "pamm.leverage"
    }],
    attrs: {
      "id": "pammLeverage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pamm, "leverage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t("select_leverage").tTitle()))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "300"
    }
  }, [_vm._v("300")])])])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.createTradingAccount('pamm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("create").tUpper()))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  }), _vm._v(" "), _c('error-modal')] : _vm._e(), _vm._v(" "), (_vm.IsDemo || !_vm.IsVerified) ? [_c('p', {
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t("upgrade_required_for_live_ta").tTitle()))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e80db5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TA/CreateLive.vue
// module id = 760
// module chunks = 0